function initBulkRouteToolbar() {
  const checkAll  = document.getElementById('check-all');
  const rowChecks = Array.from(document.querySelectorAll('.row-check'));
  const enabledRowChecks = rowChecks.filter(ch => !ch.disabled);
  const disabledRowChecks = rowChecks.filter(ch => ch.disabled);
  const toolbar   = document.getElementById('bulk-route-toolbar');
  const countEl   = document.getElementById('selected-count');
  const clearBtn  = document.getElementById('clear-selection');

  if (!rowChecks.length || !toolbar || !countEl) return;

  function updateToolbar() {
    disabledRowChecks.forEach(ch => { ch.checked = false; });

    const selected = enabledRowChecks.filter(ch => ch.checked).length;
    countEl.textContent = selected;
    toolbar.classList.toggle('d-none', selected < 2);

    if (checkAll) {
      if (selected === enabledRowChecks.length && enabledRowChecks.length > 0) {
        checkAll.checked = true;  checkAll.indeterminate = false;
      } else if (selected > 0) {
        checkAll.checked = false; checkAll.indeterminate = true;
      } else {
        checkAll.checked = false; checkAll.indeterminate = false;
      }
    }
  }

  checkAll && checkAll.addEventListener('change', () => {
    disabledRowChecks.forEach(ch => { ch.checked = false; });
    enabledRowChecks.forEach(ch => ch.checked = checkAll.checked);
    updateToolbar();
  });
  enabledRowChecks.forEach(ch => ch.addEventListener('change', updateToolbar));

  clearBtn && clearBtn.addEventListener('click', () => {
    enabledRowChecks.forEach(ch => ch.checked = false);
    updateToolbar();
  });

  const deleteModal = document.getElementById('bulkDeleteOrdersModal');
  if (deleteModal && deleteModal.dataset.bulkDeleteReady !== 'true') {
    deleteModal.dataset.bulkDeleteReady = 'true';
    deleteModal.addEventListener('show.bs.modal', event => {
      const selected = enabledRowChecks.filter(ch => ch.checked);
      if (selected.length === 0) {
        event.preventDefault();
        return;
      }

      deleteModal.querySelector('#bulk-delete-count').textContent = `${selected.length} pedido${selected.length === 1 ? '' : 's'}`;
      const fields = deleteModal.querySelector('#bulk-delete-order-ids');
      fields.replaceChildren(...selected.map(checkbox => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'order_ids[]';
        input.value = checkbox.value;
        return input;
      }));
      deleteModal.querySelector('#bulk-delete-reason').value = '';
    });
  }

  if (checkAll && enabledRowChecks.length === 0) {
    checkAll.checked = false;
    checkAll.indeterminate = false;
    checkAll.disabled = true;
  }

  updateToolbar();
}

// Com Turbo (Rails 8), rode a cada navegação
document.addEventListener('turbo:load', initBulkRouteToolbar);
// Fallback (carregamento inicial sem Turbo)
document.addEventListener('DOMContentLoaded', initBulkRouteToolbar);
